import { SxProps, Theme } from '@mui/material';
import theme from '../../theme';

export const summaryWrapStyles: SxProps<Theme> = {
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'absolute',
  zIndex: '1',
  maxWidth: '650px',
  '@media (max-width: 810px)': {
    minWidth: '420px',
  },
};
export const summaryTopStyles = ({
  type,
}: {
  type: 'error' | 'warning';
}): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '8px 16px 8px 8px',
  bgcolor: type === 'error' ? 'customColors.pink.100' : '#fef2eb',
  color: 'customColors.gray.950',
  cursor: 'pointer',
  border: `1px solid ${type === 'error' ? '#DD0F0F61' : '#FF7324'}`,
  borderRadius: '7px',
  transition: '.3s ease',
  '& svg': {
    marginRight: '8px',
  },
  '& p': {
    fontSize: '14px',
    fontWeight: '500',
    textDecoration: 'underline',
  },
  '&:hover': {
    opacity: '0.88',
  },
  maxWidth: '650px',
  '@media (max-width: 810px)': {
    maxWidth: '420px',
  },
});

export const summaryErrorsStyles = ({
  type,
}: {
  type: 'error' | 'warning';
}): SxProps<Theme> => ({
  bgcolor: type === 'error' ? 'customColors.pink.100' : '#fef2eb',
  color: 'customColors.gray.950',
  borderRadius: '6px',
  marginTop: '8px',
  padding: '16px 16px 7px 16px',
  maxHeight: '550px',
  overflow: 'auto',
  listStyle: 'none',
});

export const summaryErrorStyles = ({
  type,
}: {
  type: 'error' | 'warning';
}): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  bgcolor: type === 'error' ? 'customColors.pink.100' : '#fef2eb',
  color: 'customColors.gray.950',
  borderRadius: '6px',
  marginBottom: '9px',
  fontSize: '14px',
});

export const summaryErrorIconStyles: SxProps<Theme> = {
  display: 'inline-flex',
  marginTop: '-1px',
};

export const summaryErrorNameStyles: SxProps<Theme> = {
  marginRight: '8px',
  color: 'error.main',
  fontWeight: '500',
  fontSize: '14px',
  flexShrink: '0',
};

export const summaryErrorTextStyles = ({
  type,
}: {
  type: 'error' | 'warning';
}): SxProps<Theme> => ({
  cursor: 'pointer',
  transition: '.3s ease',
  fontSize: '14px',

  '&:hover': {
    color: type === 'error' ? 'error.main' : theme.palette.warning.main,
  },
});
